import { Card, CardHeader, CardTitle } from "../../ui/card";
import { motion } from "framer-motion";
import { RefreshCwIcon, CheckIcon } from "lucide-react";
import { humanizeToolName } from "../utils";
import { FC } from "react";

/**
 * Small status card indicating the progress of a single tool call.
 */
const ToolCallCard: FC<{ toolName: string; status: "running" | "done" }> = ({ toolName, status }) => {
  const friendly = humanizeToolName(toolName);
  return (
    <motion.div initial={{ opacity: 0, y: 5 }} animate={{ opacity: 1, y: 0 }}>
      <Card className="border-border">
        <CardHeader className="py-3">
          <div className="flex items-center gap-2">
            {/* Animated spinner while running; green check when finished */}
            {status === "running" ? (
              <RefreshCwIcon className="text-muted-foreground size-4 animate-spin" />
            ) : (
              <CheckIcon className="text-green-600 size-4" />
            )}
            <CardTitle className="text-sm">Calling {friendly}</CardTitle>
          </div>
        </CardHeader>
      </Card>
    </motion.div>
  );
};

export default ToolCallCard;
